/* eslint-disable no-control-regex */
const CONTROL_CHAR_PATTERN = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;
const cleanupText = (value) => value
    .replace(CONTROL_CHAR_PATTERN, ' ')
    .replace(/\uFFFD+/g, '')
    .replace(/\s+/g, ' ')
    .trim();
const scoreText = (value) => {
    const hangul = (value.match(/[\uAC00-\uD7A3]/g) || []).length;
    const replacement = (value.match(/\uFFFD/g) || []).length;
    const questionMarks = (value.match(/\?/g) || []).length;
    const latin1Noise = (value.match(/[\u00C0-\u00FF]/g) || []).length;
    const cjkNoise = (value.match(/[\u3400-\u9FFF\uF900-\uFAFF]/g) || []).length;
    return hangul * 4 - replacement * 5 - questionMarks * 2 - latin1Noise - cjkNoise * 2;
};
const recoverLatin1Mojibake = (value) => {
    try {
        if (typeof TextDecoder === 'undefined') {
            return value;
        }
        const bytes = new Uint8Array(Array.from(value, (char) => {
            const code = char.charCodeAt(0);
            if (code > 0xff) {
                throw new Error('not latin1 mojibake');
            }
            return code;
        }));
        return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
    }
    catch {
        return value;
    }
};
const normalizeCandidate = (value) => cleanupText(value);
export const normalizeKoreanText = (value) => {
    if (typeof value !== 'string' || value.length === 0) {
        return value;
    }
    const candidates = Array.from(new Set([value, recoverLatin1Mojibake(value)])).map((candidate) => normalizeCandidate(candidate));
    return candidates.reduce((best, candidate) => scoreText(candidate) > scoreText(best) ? candidate : best);
};
export const normalizeKoreanData = (value) => {
    if (typeof value === 'string') {
        return normalizeKoreanText(value);
    }
    if (Array.isArray(value)) {
        return value.map((item) => normalizeKoreanData(item));
    }
    if (!value || typeof value !== 'object') {
        return value;
    }
    const normalizedEntries = Object.entries(value).map(([key, child]) => [
        key,
        normalizeKoreanData(child),
    ]);
    return Object.fromEntries(normalizedEntries);
};
export const normalizeKoreanDisplayData = (value) => {
    if (typeof value === 'string') {
        return normalizeKoreanText(value);
    }
    if (Array.isArray(value)) {
        return value.map((item) => normalizeKoreanDisplayData(item));
    }
    if (!value || typeof value !== 'object') {
        return value;
    }
    const normalizedEntries = Object.entries(value).map(([key, child]) => [
        normalizeKoreanText(key),
        normalizeKoreanDisplayData(child),
    ]);
    return Object.fromEntries(normalizedEntries);
};
